import {WCBaseComponent} from './WCBaseComponent.js';

const template = document.createElement('template');

template.innerHTML = `
  <button class="wc-preset-button btn btn-sm btn-gray-200 m-1 text-nowrap shadow-sm">
    <i class="wc-preset-button-icon bi-cursor text-blue"></i>
    <br class="wc-preset-button-separator d-none">
    <span class="wc-preset-button-caption text-gray-600">Botão</span>
  </button>
`;

const presets = {
  atualizar: {
    icon: {content: 'bi-arrow-clockwise'},
    caption: {content: 'Atualizar'}
  },
  procurar: {
    icon: {content: 'bi-search'},
    caption: {content: 'Procurar'}
  },
  adicionar: {
    icon: {color: 'text-green', content: 'bi-plus-circle'},
    caption: {content: 'Adicionar'}
  },
  alterar: {
    icon: {content: 'bi-pencil'},
    caption: {content: 'Alterar'}
  },
  excluir: {
    icon: {color: 'text-red', content: 'bi-trash'},
    caption: {content: 'Excluir'}
  },
  copiar: {
    icon: {color: 'text-blue', content: 'bi-copy'},
    caption: {content: 'Copiar'}
  },
  ajuda: {
    icon: {content: 'bi-question-circle'},
    caption: {content: 'Ajuda'}
  },
  preferencias: {
    icon: {color: 'text-teal', content: 'bi-sliders'},
    caption: {content: 'Preferências'}
  },
  configuracoes: {
    icon: {content: 'bi-gear'},
    caption: {content: 'Configurações'}
  }
};

export class WCPresetButton extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    // let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcPresetButton = clone.content.querySelector('.wc-preset-button');
    let wcPresetButtonIcon = clone.content.querySelector('.wc-preset-button-icon');
    let wcPresetButtonSeparator = clone.content.querySelector('.wc-preset-button-separator');
    let wcPresetButtonCaption = clone.content.querySelector('.wc-preset-button-caption');
    let dataContext = this.getAttribute('data-context');
    let dataPreset = this.getAttribute('data-preset');
    let dataCaptionContent = this.getAttribute('data-caption-content');
    let dataContent = $$.tool.dataJSON(this.getAttribute('data-content'));
    let dataClassText = this.getAttribute('data-class-text');
    let dataButtonColor = this.getAttribute('data-button-color');
    wcPresetButton.setAttribute('class', [this.getAttribute('class'), wcPresetButton.getAttribute('class')].join(' '));
    this.removeAttribute('class');
    if (dataClassText !== null) {
      wcPresetButton.classList.add(dataClassText);
      wcPresetButtonIcon.classList.remove('text-blue');
      wcPresetButtonCaption.classList.remove('text-gray-600');
    }
    if (dataButtonColor !== null) {
      wcPresetButton.classList.remove('btn-gray-200');
      wcPresetButton.classList.add(dataButtonColor);
      wcPresetButtonIcon.classList.remove('text-blue');
      wcPresetButtonCaption.classList.remove('text-gray-600');
    }
    if (dataPreset !== null && presets[dataPreset] !== undefined) {
      let preset = presets[dataPreset];
      if (preset.icon.color !== undefined && dataClassText === null && dataButtonColor === null) {
        wcPresetButtonIcon.classList.remove('text-blue');
        wcPresetButtonIcon.classList.add(preset.icon.color);
      }
      wcPresetButtonIcon.classList.remove('bi-cursor');
      wcPresetButtonIcon.classList.add(preset.icon.content);
      wcPresetButtonCaption.textContent = dataCaptionContent === null ? preset.caption.content : dataCaptionContent;
    }
    if (dataContent !== null) {
      for (let data in dataContent) {
        wcPresetButton.dataset[data] = dataContent[data];
      }
    }
    switch (dataContext) {
    case 'toolbar':
      wcPresetButtonSeparator.classList.add('d-md-block');
      break;
    case 'resultset':
      wcPresetButton.classList.remove('btn-sm', 'm-1');
      wcPresetButton.classList.add('btn-sm', 'ms-1');
      break;
    case 'resultset-toolbar':
      wcPresetButton.classList.remove('btn-sm');
      wcPresetButton.classList.add('btn-xs');
      break;
    }
    this.replaceWith(wcPresetButton);
  }

}